var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#FFF","d":"M14 0l2 2-8 8-8-8 2-2 6 6z","fillRule":"nonzero"}));
}

Arrow.defaultProps = {"width":"16","height":"10"};

module.exports = Arrow;

Arrow.default = Arrow;
